import type {QueryClient} from '@tanstack/react-query'
import {QUERY_KEYS} from '@/queryClient'

export const invalidateActivityReportExportAvailability = (queryClient: QueryClient) => {
    void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.PRI_TXT_AVAILABLE_MONTHS]})
    void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.MERGED_REPORT_AVAILABLE_MONTHS]})
}
